import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  AccessRight,
  NewApplicationValues,
} from '../../../new-application/types';
import { applicationsApi } from '../../../new-application/store/services';

export interface CreateIndividualCustomertState {
  requestInProgress?: boolean;
  formValues: NewApplicationValues;
  panelIsOpen: boolean;
  submitSuccess?: boolean;
}

export const defaultFormValues = {
  accessRight: AccessRight.VIEWER,
  applicantId: '',
  deliveryChannelId: '',
  dob: '',
  email: '',
  firstName: '',
  isUSResident: false,
  lastName: '',
  nationalityId: '',
  participatesInPolitics: false,
  phone: '',
  signatureType: '',
  applicationSchemeId: '',
};

const initialState: CreateIndividualCustomertState = {
  requestInProgress: false,
  panelIsOpen: false,
  formValues: defaultFormValues,
  submitSuccess: false,
};

export const individualCustomerCreateSlice = createSlice({
  name: 'individualCustomerCreate',
  initialState,
  reducers: {
    changePanelState: (state, action: PayloadAction<boolean>) => {
      state.panelIsOpen = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      applicationsApi.endpoints.createApplication.matchFulfilled,
      (state) => {
        state.submitSuccess = true;
      },
    );
  },
});

export const { changePanelState } = individualCustomerCreateSlice.actions;

export default individualCustomerCreateSlice.reducer;
